import {doc} from './docs.js';

doc(
    "document.title",
    {
        "title": ""
    },
    "Sets the title of the webpage to the argument passed"
);
export const title = () => {
    return ([name]) => {
        window.document.title = name;
    }
};
